import Image from 'next/image'
import React, { useState } from 'react'

import { Text } from '@wartek-id/text-v1'
// import { ProgressBar } from '@wartek-id/progress-bar'
// import { Button } from '@wartek-id/button-v1'

import { useApiCompetencyMappingResult } from 'api/competency-mapping/useAPICompetencyMapping'
import {
  CPKvKeys,
  useGetCPKeyPairValue,
} from 'api/content-platform/useAPIKeyValue'
import LoadingState from 'app/PemetaanKompetensiPage/components/LoadingState'
import { useUserGroupSjt } from 'utils/hooks/useUserGroup'
import ForbiddenPage from '../components/ForbiddenPage'
import HelpBlock from '../components/HelpBlock'
import PeriodGuard from '../components/PeriodGuard'
import SpinnerLoading from '../components/SpinnerLoading'
import UjikomCard from '../components/UjikomCard'
import { useSETrackEvent } from '../hooks/useSETrackEvent'
import PassedDecisionDialog from '../components/PassedDecisionDialog'

import type { IUjikomData, IUjikomPeriodData } from 'types/content-platform'

interface IUjikomMainListResponse {
  list: IUjikomData[]
}

const Main = ({ currentDateTimeServer }) => {
  const { trackHomeOpen } = useSETrackEvent()
  const { hasAccess: hasNecessaryRole, isLoading: isLoadingNecessaryRole } =
    useUserGroupSjt()
  const isUjikomWhitelisted = !isLoadingNecessaryRole && hasNecessaryRole
  const [showPassedDecisionDialog, setShowPassedDecisionDialog] =
    useState(false)

  const assesmentType = 'SJT'
  const {
    isLoading: isLoadingResult,
    data: UjikomDataResult,
    isSuccess: isSuccessResult,
  } = useApiCompetencyMappingResult(assesmentType, true)

  const {
    isLoading,
    data: ujikomData,
    isSuccess,
  } = useGetCPKeyPairValue<IUjikomMainListResponse>(
    CPKvKeys.UjikomMainContent,
    isUjikomWhitelisted
  )

  const {
    isLoading: isLoadingUjikomPeriod,
    data: ujikomPeriodData,
    isSuccess: isSuccessPeriod,
  } = useGetCPKeyPairValue<IUjikomPeriodData>(
    CPKvKeys.UjikomPeriodContent,
    isUjikomWhitelisted
  )

  React.useEffect(() => {
    if (isSuccessPeriod && isSuccessResult) {
      trackHomeOpen({
        pemKomPeriod: ujikomPeriodData?.data,
        isPemKomEnabled: isUjikomWhitelisted,
        hasCertificate: [
          'FORM_COMPLETED',
          'FORM_CERTIFICATE_GENERATED',
        ].includes(UjikomDataResult?.metadata.state),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessPeriod, isSuccessResult])

  const isDoneResult = !isLoadingResult && isSuccessResult
  const isDonePeriod = !isLoadingUjikomPeriod && isSuccessPeriod

  const showUjikomList = React.useMemo(() => {
    if (
      !isLoading &&
      isSuccess &&
      !!ujikomData.data.list.length &&
      isDoneResult &&
      isDonePeriod
    ) {
      return ujikomData.data.list.filter((thisData) => thisData.show)
    }
    return []
  }, [ujikomData, isLoading, isSuccess, isDoneResult, isDonePeriod])

  // To be displayed only if the role is being validated
  if (isLoadingNecessaryRole)
    return <LoadingState title="Halaman sedang dimuat..." />

  // const showCompetencyList = React.useMemo(() => {
  //   if (isDoneResult && !!UjikomDataResult.data.competencies.length) {
  //     return UjikomDataResult.data.competencies
  //   }
  //   return []
  // }, [isDoneResult, UjikomDataResult])
  if (!isUjikomWhitelisted) return <ForbiddenPage />

  const RenderUjikomList = () => {
    return (
      <>
        {showUjikomList.map((thisUjikomData, index) => (
          <UjikomCard
            UjikomData={thisUjikomData}
            key={`list_ujikom_${index}`}
            UjikomResult={UjikomDataResult?.data}
            UjikomState={UjikomDataResult?.metadata.state}
            currentDateTimeServer={currentDateTimeServer}
            UjikomPeriod={ujikomPeriodData.data}
            handleOpenMore={() => setShowPassedDecisionDialog(true)}
          />
        ))}
      </>
    )
  }

  // const RenderCompetencyList = () => {
  //   return (
  //     <>
  //       {showCompetencyList.length > 0 && (
  //         <div className="bg-white flex flex-col items-center justify-cemter rounded-lg mx-4 mb-5 py-6 px-4">
  //           {showCompetencyList.map((thisCompetency) => (
  //             <span className="w-full mb-5" key={thisCompetency.key}>
  //               <ProgressBar max={5} value={thisCompetency.level} />
  //               <span className="flex mt-1">
  //                 <Text variant="body-bold">{thisCompetency.name}:&nbsp;</Text>
  //                 <Text variant="body">Level {thisCompetency.level}</Text>
  //               </span>
  //             </span>
  //           ))}
  //           <Button fullWidth color="white">
  //             Lihat Semua
  //           </Button>
  //         </div>
  //       )}
  //     </>
  //   )
  // }
  return (
    <div className="bg-gray-10 m-auto max-w-ujikom">
      <PeriodGuard
        fullPageLoading
        currentDateTimeServer={currentDateTimeServer}
      >
        <div className="py-4">
          <div className="bg-white flex items-center justify-left rounded-lg mx-4 mb-5 py-4 px-3">
            <Image
              layout="fixed"
              src="/images/ujikom/img-doc-file-graphic-chart.png"
              alt="ujikom-data"
              width={80}
              height={80}
            />
            <Text variant="body" className="flex-1 ml-3">
              Dapatkan sertifikat kelulusan Uji Kompetensi sebagai syarat
              Pengangkatan Jabatan Fungsional (JF) Guru.
            </Text>
          </div>
          {/* <SpinnerLoading isLoading={isLoading && isLoadingResult} /> */}
          {/* {isSuccessResult && <RenderCompetencyList />} */}
          <SpinnerLoading isLoading={isLoading && isLoadingResult} />
          {isSuccess && <RenderUjikomList />}
          <HelpBlock className="mx-4 mb-4 mt-5" />
        </div>
        <PassedDecisionDialog
          isOpen={showPassedDecisionDialog}
          handleClose={() => setShowPassedDecisionDialog(false)}
          state={UjikomDataResult?.metadata.state}
        />
      </PeriodGuard>
    </div>
  )
}

export default Main
